export const ValidationRules = Object.freeze({
    IS_NUMERIC: 'isNumeric',
    MINIMUM_VALUE: 'minimumValue',
    MAXIMUM_VALUE: 'maximumValue',
    MAXIMUM_LENGTH: 'lengthMax',
    MINIMUM_LENGTH: 'lengthMin',
});
